function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  d: "M0.5 5C0.5 2.51472 2.51472 0.5 5 0.5H75C77.4853 0.5 79.5 2.51472 79.5 5V47C79.5 49.4853 77.4853 51.5 75 51.5H5C2.51472 51.5 0.5 49.4853 0.5 47V5Z",
  fill: "white",
  stroke: "#D6DFDF"
});

var _ref3 = React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.9388 8.52532C11.6806 8.52532 12.3626 8.77147 12.9043 9.18324L13.4144 8.64885C12.7377 8.11812 11.8767 7.79999 10.9388 7.79999C8.76322 7.79999 7 9.50869 7 11.6161C7 13.7234 8.76322 15.4318 10.9388 15.4318C11.8767 15.4318 12.7377 15.1137 13.4144 14.5839L12.8854 14.0623C12.3464 14.4649 11.6719 14.7068 10.9388 14.7068C9.1768 14.7068 7.74835 13.3232 7.74835 11.6161C7.74835 9.90887 9.1768 8.52532 10.9388 8.52532ZM46.0451 12.7245L41.8509 7.88875H40.3105V15.3065H41.9837V10.4732L46.1121 15.3065H47.7143V7.88875H46.0451V12.7245ZM50.2897 13.9473V12.1352H52.4032V10.8038H50.2897V9.22043H53.9418V7.88842H48.7163V15.3348H54.02V13.9473H50.2897ZM27.4187 11.2885C28.1993 11.5718 28.7556 12.302 28.7556 13.1558V13.3318C28.7556 14.4308 27.8326 15.3251 26.6983 15.3251H24.2264V7.90949H25.9096C27.0442 7.90949 27.9672 8.80319 27.9672 9.90278V9.9348C27.9672 10.457 27.7591 10.9328 27.4187 11.2885ZM25.0168 11.1625H25.9095C26.6085 11.1625 27.1766 10.6116 27.1766 9.9348V9.90278C27.1766 9.22564 26.6085 8.67508 25.9095 8.67508H25.0168V11.1625ZM27.9656 13.1558C27.9656 12.4786 27.3972 11.9281 26.6982 11.9281H25.0168V14.5588H26.6982C27.3972 14.5588 27.9656 14.0083 27.9656 13.3318V13.1558ZM22.631 12.8645C22.631 13.8802 21.8144 14.7062 20.8107 14.7062H20.7663C19.7626 14.7062 18.946 13.8802 18.946 12.8645V7.91804H18.1555V12.8645C18.1555 14.3026 19.3267 15.4724 20.7663 15.4724H20.8107C22.2503 15.4724 23.4215 14.3026 23.4215 12.8645V7.91804H22.631V12.8645ZM14.9309 7.91804H14.1404V15.3065H17.9411V14.4948H14.9309V7.91804ZM35.5634 7.79999C37.739 7.79999 39.5022 9.50869 39.5022 11.6164C39.5022 13.7234 37.739 15.4321 35.5634 15.4321C33.3878 15.4321 31.6246 13.7234 31.6246 11.6164C31.6246 9.50869 33.3878 7.79999 35.5634 7.79999ZM35.5634 13.9412C36.9106 13.9412 38.0027 12.8828 38.0027 11.5779C38.0027 10.2728 36.9106 9.21465 35.5634 9.21465C34.2166 9.21465 33.1245 10.2728 33.1245 11.5779C33.1245 12.8828 34.2166 13.9412 35.5634 13.9412Z",
  fill: "black"
});

var _ref4 = React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 1,
  y: 1,
  width: 78,
  height: 50
}, React.createElement("path", {
  d: "M1 5C1 2.79086 2.79086 1 5 1H75C77.2091 1 79 2.79086 79 5V47C79 49.2091 77.2091 51 75 51H5C2.79086 51 1 49.2091 1 47V5Z",
  fill: "#D6DFDF"
}));

var _ref5 = React.createElement("g", {
  mask: "url(#mask0)"
}, React.createElement("path", {
  d: "M76.7502 0.330002C78.6502 1.04 80.0002 2.85 80.0002 5V25.79H58.6902C58.6902 14.06 66.2202 4.08 76.7502 0.330002ZM75.0002 52C75.8202 52 76.5902 51.78 77.2702 51.43C66.4702 47.83 58.6902 37.72 58.6902 25.8C58.6902 38.42 49.9702 49.02 38.1802 52H75.0002Z",
  fill: "black"
}));

var SvgClubOneCardBronze = function SvgClubOneCardBronze(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 80,
    height: 52,
    viewBox: "0 0 80 52",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClubOneCardBronze, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/club-one-card-bronze.c5cd100d.svg";
export { ForwardRef as ReactComponent };